import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdModalities() {
  return useQuery({
    queryKey: ['rd-modalities'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getModalities();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar as modalidades do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
